<template>
    <div class="view-inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>

        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-header-title"><i class="bi bi-box-seam"></i> Gestión de Tipos de Unidades</h1>
            <div class="page-header-actions">
                <button class="btn-add" @click="abrirModalTipoUnidad()">
                    <i class="bi bi-plus-lg"></i> Agregar Tipo de Unidad
                </button>
            </div>
        </div>

        <!-- Filtros -->
        <div class="filter-card">
            <div class="row">
                <div class="col-md-4">
                    <label class="form-label">Tipo de Unidad</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.tipo_unidad" placeholder="Buscar por tipo...">
                </div>
                <div class="col-md-2">
                    <label class="form-label">Estado</label>
                    <select class="form-select form-select-sm" v-model="filtros.estado">
                        <option value="">Todos</option>
                        <option value="1">Activo</option>
                        <option value="0">Inactivo</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">&nbsp;</label>
                    <div class="filter-actions">
                        <button class="btn-clear" @click="limpiarFiltros"><i class="bi bi-x-circle"></i> Limpiar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla (estándar: ESTANDAR_LISTADOS.md) -->
        <div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                                <th>ID</th>
                                <th>Estado</th>
                                <th>Tipo Unidad</th>
                                <th>N° Pallets</th>
                                <th>Cap. Peso (TN)</th>
                                <th>Cap. Carga (M³)</th>
                                <th>Medidas Transporte</th>
                                <th>Costo Diario</th>
                                <th>Costo Mensual</th>
                                <th class="col-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="tipo in paginar(tiposUnidadesFiltrados)" :key="tipo.id">
                                <td class="celda-id">{{ tipo.id }}</td>
                                <td>
                                    <span :class="tipo.estado ? 'badge-activo' : 'badge-inactivo'">
                                        {{ tipo.estado ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </td>
                                <td class="celda-entidad"><div class="entidad-nombre" :title="tipo.tipo_unidad">{{ tipo.tipo_unidad }}</div></td>
                                <td>{{ tipo.nro_pallets || '-' }}</td>
                                <td>{{ parseFloat(tipo.capacidad_peso || 0).toFixed(2) }}</td>
                                <td>{{ parseFloat(tipo.capacidad_carga || 0).toFixed(4) }}</td>
                                <td>{{ tipo.medidas_transporte }}</td>
                                <td>S/. {{ parseFloat(tipo.costo_diario || 0).toFixed(2) }}</td>
                                <td>S/. {{ parseFloat(tipo.costo_mensual || 0).toFixed(2) }}</td>
                                <td class="col-acciones">
                                    <button class="btn-icon btn-icon-view" @click="verDetalle(tipo)" title="Ver detalle" aria-label="Ver detalle">
                                        <i class="bi bi-eye"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-edit" @click="editarTipoUnidad(tipo)" title="Editar" aria-label="Editar">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-del" @click="eliminarTipoUnidad(tipo.id)" title="Eliminar" aria-label="Eliminar">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!tiposUnidadesFiltrados.length" class="empty-row">
                                <td colspan="10">No se encontraron tipos de unidades</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <PaginacionListado :pagina="paginaActualDe(tiposUnidadesFiltrados)" :total-paginas="totalPaginasDe(tiposUnidadesFiltrados)"
                :total="tiposUnidadesFiltrados.length" :por-pagina="porPagina" :en-pagina="paginar(tiposUnidadesFiltrados).length"
                etiqueta="tipos de unidades" @cambiar="pagina = $event" />
        </div>

        <!-- Modal para Tipo de Unidad -->
        <div v-if="showModalTipo" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicion ? 'Editar Tipo de Unidad' : 'Nuevo Tipo de Unidad' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalTipo"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarTipoUnidad">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="tipoUnidad" class="form-label required">Tipo de Unidad</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="tipoUnidad" 
                                            v-model="formTipo.tipo_unidad"
                                            :class="{ 'is-invalid': errors.tipo_unidad }"
                                            placeholder="Ingrese el tipo de unidad"
                                            maxlength="255"
                                            required
                                        >
                                        <div v-if="errors.tipo_unidad" class="invalid-feedback">
                                            {{ errors.tipo_unidad }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="nroPallets" class="form-label">N° Pallets</label>
                                        <input 
                                            type="number" 
                                            class="form-control" 
                                            id="nroPallets" 
                                            v-model="formTipo.nro_pallets"
                                            :class="{ 'is-invalid': errors.nro_pallets }"
                                            placeholder="Número de pallets"
                                            min="0"
                                        >
                                        <div v-if="errors.nro_pallets" class="invalid-feedback">
                                            {{ errors.nro_pallets }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <div class="form-check mt-4">
                                            <input 
                                                class="form-check-input" 
                                                type="checkbox" 
                                                id="estado" 
                                                v-model="formTipo.estado"
                                            >
                                            <label class="form-check-label" for="estado">
                                                Activo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="capacidadPeso" class="form-label required">Capacidad de Peso (TN)</label>
                                        <input 
                                            type="number" 
                                            step="0.01" 
                                            class="form-control" 
                                            id="capacidadPeso" 
                                            v-model="formTipo.capacidad_peso"
                                            :class="{ 'is-invalid': errors.capacidad_peso }"
                                            placeholder="0.00"
                                            min="0"
                                            required
                                        >
                                        <div v-if="errors.capacidad_peso" class="invalid-feedback">
                                            {{ errors.capacidad_peso }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="capacidadCarga" class="form-label required">Capacidad de Carga (M³)</label>
                                        <input 
                                            type="number" 
                                            step="0.0001" 
                                            class="form-control" 
                                            id="capacidadCarga" 
                                            v-model="formTipo.capacidad_carga"
                                            :class="{ 'is-invalid': errors.capacidad_carga }"
                                            placeholder="0.0000"
                                            min="0"
                                            required
                                        >
                                        <div v-if="errors.capacidad_carga" class="invalid-feedback">
                                            {{ errors.capacidad_carga }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="medidasTransporte" class="form-label required">Medidas del Transporte</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="medidasTransporte" 
                                            v-model="formTipo.medidas_transporte"
                                            :class="{ 'is-invalid': errors.medidas_transporte }"
                                            placeholder="Ej: 4.5m x 2.5m x 2.5m"
                                            maxlength="50"
                                            required
                                        >
                                        <div v-if="errors.medidas_transporte" class="invalid-feedback">
                                            {{ errors.medidas_transporte }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="costoDiario" class="form-label required">Costo Diario (S/.)</label>
                                        <input 
                                            type="number" 
                                            step="0.01" 
                                            class="form-control" 
                                            id="costoDiario" 
                                            v-model="formTipo.costo_diario"
                                            :class="{ 'is-invalid': errors.costo_diario }"
                                            placeholder="0.00"
                                            min="0"
                                            required
                                        >
                                        <div v-if="errors.costo_diario" class="invalid-feedback">
                                            {{ errors.costo_diario }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="costoMensual" class="form-label required">Costo Mensual (S/.)</label>
                                        <input 
                                            type="number" 
                                            step="0.01" 
                                            class="form-control" 
                                            id="costoMensual" 
                                            v-model="formTipo.costo_mensual"
                                            :class="{ 'is-invalid': errors.costo_mensual }"
                                            placeholder="0.00"
                                            min="0"
                                            required
                                        >
                                        <div v-if="errors.costo_mensual" class="invalid-feedback">
                                            {{ errors.costo_mensual }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="costoAuxiliarExtra" class="form-label">Costo Auxiliar Extra (S/.)</label>
                                        <input 
                                            type="number" 
                                            step="0.01" 
                                            class="form-control" 
                                            id="costoAuxiliarExtra" 
                                            v-model="formTipo.costo_auxiliar_extra"
                                            :class="{ 'is-invalid': errors.costo_auxiliar_extra }"
                                            placeholder="0.00"
                                            min="0"
                                        >
                                        <div v-if="errors.costo_auxiliar_extra" class="invalid-feedback">
                                            {{ errors.costo_auxiliar_extra }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="costoCuadrilla" class="form-label">Costo Cuadrilla (S/.)</label>
                                        <input 
                                            type="number" 
                                            step="0.01" 
                                            class="form-control" 
                                            id="costoCuadrilla" 
                                            v-model="formTipo.costo_cuadrilla"
                                            :class="{ 'is-invalid': errors.costo_cuadrilla }"
                                            placeholder="0.00"
                                            min="0"
                                        >
                                        <div v-if="errors.costo_cuadrilla" class="invalid-feedback">
                                            {{ errors.costo_cuadrilla }}
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-4">
                                    <div class="mb-3">
                                        <label for="costoHoraExtra" class="form-label">Costo Hora Extra (S/.)</label>
                                        <input 
                                            type="number" 
                                            step="0.01" 
                                            class="form-control" 
                                            id="costoHoraExtra" 
                                            v-model="formTipo.costo_hora_extra"
                                            :class="{ 'is-invalid': errors.costo_hora_extra }"
                                            placeholder="0.00"
                                            min="0"
                                        >
                                        <div v-if="errors.costo_hora_extra" class="invalid-feedback">
                                            {{ errors.costo_hora_extra }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-3">
                                        <label for="horarioLaboral" class="form-label required">Horario Laboral</label>
                                        <textarea 
                                            class="form-control" 
                                            id="horarioLaboral" 
                                            v-model="formTipo.horario_laboral"
                                            :class="{ 'is-invalid': errors.horario_laboral }"
                                            placeholder="Ej: Lunes a Viernes: 8:00 AM - 6:00 PM, Sábados: 8:00 AM - 12:00 PM"
                                            rows="3"
                                            required
                                        ></textarea>
                                        <div v-if="errors.horario_laboral" class="invalid-feedback">
                                            {{ errors.horario_laboral }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalTipo">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarTipoUnidad" :disabled="isLoading">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal para Ver Detalle -->
        <div v-if="showModalDetalle" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Detalle del Tipo de Unidad - {{ tipoSeleccionado?.tipo_unidad }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModalDetalle"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="tipoSeleccionado">
                            <div class="col-md-6">
                                <table class="table table-bordered">
                                    <tr>
                                        <td class="fw-bold">ID:</td>
                                        <td>{{ tipoSeleccionado.id }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Estado:</td>
                                        <td>
                                            <span :class="tipoSeleccionado.estado ? 'badge bg-success' : 'badge bg-danger'">
                                                {{ tipoSeleccionado.estado ? 'Activo' : 'Inactivo' }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Tipo de Unidad:</td>
                                        <td>{{ tipoSeleccionado.tipo_unidad }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">N° Pallets:</td>
                                        <td>{{ tipoSeleccionado.nro_pallets || '-' }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Capacidad de Peso:</td>
                                        <td>{{ parseFloat(tipoSeleccionado.capacidad_peso || 0).toFixed(2) }} TN</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Capacidad de Carga:</td>
                                        <td>{{ parseFloat(tipoSeleccionado.capacidad_carga || 0).toFixed(4) }} M³</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Medidas del Transporte:</td>
                                        <td>{{ tipoSeleccionado.medidas_transporte }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-6">
                                <table class="table table-bordered">
                                    <tr>
                                        <td class="fw-bold">Costo Diario:</td>
                                        <td>S/. {{ parseFloat(tipoSeleccionado.costo_diario || 0).toFixed(2) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Costo Mensual:</td>
                                        <td>S/. {{ parseFloat(tipoSeleccionado.costo_mensual || 0).toFixed(2) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Costo Auxiliar Extra:</td>
                                        <td>S/. {{ parseFloat(tipoSeleccionado.costo_auxiliar_extra || 0).toFixed(2) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Costo Cuadrilla:</td>
                                        <td>S/. {{ parseFloat(tipoSeleccionado.costo_cuadrilla || 0).toFixed(2) }}</td>
                                    </tr>
                                    <tr>
                                        <td class="fw-bold">Costo Hora Extra:</td>
                                        <td>S/. {{ parseFloat(tipoSeleccionado.costo_hora_extra || 0).toFixed(2) }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header bg-light">
                                        <h6 class="mb-0">Horario Laboral</h6>
                                    </div>
                                    <div class="card-body">
                                        <p class="mb-0">{{ tipoSeleccionado.horario_laboral }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModalDetalle">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionLocal from '@/mixins/paginacionLocal'

export default {
    name: 'GestionTiposUnidades',
    components: { PaginacionListado },
    mixins: [paginacionLocal],
    watch: {
        // Los filtros se aplican al escribir: cualquier cambio vuelve a la página 1
        filtros: { deep: true, handler() { this.pagina = 1 } },
    },
    data() {
        return {
            isLoading: false,
            
            // Modales
            showModalTipo: false,
            showModalDetalle: false,
            
            // Modos de edición
            modoEdicion: false,
            
            // Datos
            tiposUnidades: [],
            tipoSeleccionado: null,
            
            // Filtros
            filtros: {
                tipo_unidad: '',
                estado: ''
            },
            
            // Formulario
            formTipo: {
                id: null,
                estado: true,
                tipo_unidad: '',
                nro_pallets: null,
                capacidad_peso: null,
                capacidad_carga: null,
                medidas_transporte: '',
                costo_diario: null,
                costo_mensual: null,
                costo_auxiliar_extra: null,
                costo_cuadrilla: null,
                costo_hora_extra: null,
                horario_laboral: ''
            },
            
            // Errores
            errors: {}
        }
    },
    computed: {
        tiposUnidadesFiltrados() {
            let filtrados = this.tiposUnidades

            if (this.filtros.tipo_unidad) {
                filtrados = filtrados.filter(tipo =>
                    tipo.tipo_unidad.toLowerCase().includes(this.filtros.tipo_unidad.toLowerCase())
                )
            }

            if (this.filtros.estado !== '') {
                filtrados = filtrados.filter(tipo => 
                    tipo.estado.toString() === this.filtros.estado
                )
            }

            return filtrados
        }
    },
    async mounted() {
        await this.cargarTiposUnidades()
    },
    methods: {
        // Cargar datos
        async cargarTiposUnidades() {
            this.isLoading = true
            try {
                const response = await axios.get('tipo-unidades')
                this.tiposUnidades = response.data
            } catch (error) {
                console.error('Error cargando tipos de unidades:', error)
                Swal.fire('Error', 'Error al cargar los tipos de unidades', 'error')
            } finally {
                this.isLoading = false
            }
        },

        // Filtros (se aplican automáticamente mediante computed)
        limpiarFiltros() {
            this.filtros = {
                tipo_unidad: '',
                estado: ''
            }
        },

        // Modal principal
        abrirModalTipoUnidad() {
            this.modoEdicion = false
            this.formTipo = {
                id: null,
                estado: true,
                tipo_unidad: '',
                nro_pallets: null,
                capacidad_peso: null,
                capacidad_carga: null,
                medidas_transporte: '',
                costo_diario: null,
                costo_mensual: null,
                costo_auxiliar_extra: null,
                costo_cuadrilla: null,
                costo_hora_extra: null,
                horario_laboral: ''
            }
            this.errors = {}
            this.showModalTipo = true
        },

        editarTipoUnidad(tipo) {
            this.modoEdicion = true
            this.formTipo = {
                id: tipo.id,
                estado: Boolean(tipo.estado),
                tipo_unidad: tipo.tipo_unidad,
                nro_pallets: tipo.nro_pallets,
                capacidad_peso: parseFloat(tipo.capacidad_peso),
                capacidad_carga: parseFloat(tipo.capacidad_carga),
                medidas_transporte: tipo.medidas_transporte,
                costo_diario: parseFloat(tipo.costo_diario),
                costo_mensual: parseFloat(tipo.costo_mensual),
                costo_auxiliar_extra: tipo.costo_auxiliar_extra ? parseFloat(tipo.costo_auxiliar_extra) : null,
                costo_cuadrilla: tipo.costo_cuadrilla ? parseFloat(tipo.costo_cuadrilla) : null,
                costo_hora_extra: tipo.costo_hora_extra ? parseFloat(tipo.costo_hora_extra) : null,
                horario_laboral: tipo.horario_laboral
            }
            this.errors = {}
            this.showModalTipo = true
        },

        cerrarModalTipo() {
            this.showModalTipo = false
            this.errors = {}
        },

        // Modal detalle
        verDetalle(tipo) {
            this.tipoSeleccionado = tipo
            this.showModalDetalle = true
        },

        cerrarModalDetalle() {
            this.showModalDetalle = false
            this.tipoSeleccionado = null
        },

        // Validación
        validarFormulario() {
            this.errors = {}

            if (!this.formTipo.tipo_unidad.trim()) {
                this.errors.tipo_unidad = 'El tipo de unidad es requerido'
            }

            if (!this.formTipo.capacidad_peso || this.formTipo.capacidad_peso <= 0) {
                this.errors.capacidad_peso = 'La capacidad de peso debe ser mayor a 0'
            }

            if (!this.formTipo.capacidad_carga || this.formTipo.capacidad_carga <= 0) {
                this.errors.capacidad_carga = 'La capacidad de carga debe ser mayor a 0'
            }

            if (!this.formTipo.medidas_transporte.trim()) {
                this.errors.medidas_transporte = 'Las medidas del transporte son requeridas'
            }

            if (!this.formTipo.costo_diario || this.formTipo.costo_diario <= 0) {
                this.errors.costo_diario = 'El costo diario debe ser mayor a 0'
            }

            if (!this.formTipo.costo_mensual || this.formTipo.costo_mensual <= 0) {
                this.errors.costo_mensual = 'El costo mensual debe ser mayor a 0'
            }

            if (!this.formTipo.horario_laboral.trim()) {
                this.errors.horario_laboral = 'El horario laboral es requerido'
            }

            return Object.keys(this.errors).length === 0
        },

        // Guardar
        async guardarTipoUnidad() {
            if (!this.validarFormulario()) {
                return
            }

            this.isLoading = true
            try {
                const data = {
                    estado: this.formTipo.estado ? 1 : 0,
                    tipo_unidad: this.formTipo.tipo_unidad.trim(),
                    nro_pallets: this.formTipo.nro_pallets,
                    capacidad_peso: this.formTipo.capacidad_peso,
                    capacidad_carga: this.formTipo.capacidad_carga,
                    medidas_transporte: this.formTipo.medidas_transporte.trim(),
                    costo_diario: this.formTipo.costo_diario,
                    costo_mensual: this.formTipo.costo_mensual,
                    costo_auxiliar_extra: this.formTipo.costo_auxiliar_extra,
                    costo_cuadrilla: this.formTipo.costo_cuadrilla,
                    costo_hora_extra: this.formTipo.costo_hora_extra,
                    horario_laboral: this.formTipo.horario_laboral.trim()
                }

                if (this.modoEdicion) {
                    await axios.put(`tipo-unidades/${this.formTipo.id}`, data)
                    Swal.fire('Éxito', 'Tipo de unidad actualizado correctamente', 'success')
                } else {
                    await axios.post('tipo-unidades', data)
                    Swal.fire('Éxito', 'Tipo de unidad creado correctamente', 'success')
                }
                
                this.cerrarModalTipo()
                await this.cargarTiposUnidades()
            } catch (error) {
                console.error('Error guardando tipo de unidad:', error)
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors
                } else {
                    Swal.fire('Error', error.response?.data?.message || 'Error al guardar el tipo de unidad', 'error')
                }
            } finally {
                this.isLoading = false
            }
        },

        // Eliminar
        async eliminarTipoUnidad(id) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            })

            if (result.isConfirmed) {
                this.isLoading = true
                try {
                    await axios.delete(`tipo-unidades/${id}`)
                    Swal.fire('Eliminado', 'Tipo de unidad eliminado correctamente', 'success')
                    await this.cargarTiposUnidades()
                } catch (error) {
                    console.error('Error eliminando tipo de unidad:', error)
                    Swal.fire('Error', error.response?.data?.message || 'Error al eliminar el tipo de unidad', 'error')
                } finally {
                    this.isLoading = false
                }
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.modal.show {
    display: block !important;
}

.badge {
    font-size: 0.8em;
}

.text-danger {
    color: #dc3545 !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
}

.required::after {
    content: ' *';
    color: red;
}

</style>